import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { savedItemsApi } from '../lib/api';

// Tipi di elemento salvabile da LinkedIn tramite l'estensione Chrome
export type SavedItemKind = 'post' | 'profile' | 'engagement' | 'dm';

// Elemento salvato come restituito dall'API
export interface SavedItem {
  id: string;
  contact_id: string | null;
  kind: SavedItemKind;
  source: string | null;
  url: string | null;
  title: string | null;
  content: string | null;
  author_name: string | null;
  author_linkedin_url: string | null;
  raw: unknown;
  ai_summary: string | null;
  ai_tags: string[];
  created_at: string;
}

// Parametri di filtro per l'elenco degli elementi salvati
export interface SavedItemsFilter {
  kind?: SavedItemKind;
  contact_id?: string;
  q?: string;
}

export function useSavedItems(filter: SavedItemsFilter = {}) {
  const query = useQuery({
    queryKey: ['saved-items', filter],
    queryFn: async () => {
      const res = await savedItemsApi.list(filter);
      const items = (res?.saved_items ?? res?.items ?? res ?? []) as SavedItem[];
      // Difensivo: ai_tags puo' mancare nelle risposte del backend in sviluppo
      return items.map((it) => ({ ...it, ai_tags: it.ai_tags ?? [] }));
    },
  });
  // Espone esplicitamente refetch/isFetching (gia' presenti su useQuery) cosi'
  // il chiamante puo' offrire un pulsante "Aggiorna" senza reimplementare la query.
  return { ...query, refetch: query.refetch, isFetching: query.isFetching };
}

export function useDeleteSavedItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => savedItemsApi.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['saved-items'] });
      // Il dettaglio contatto include i saved_items: va invalidato anche lui
      qc.invalidateQueries({ queryKey: ['contact'] });
    },
  });
}
